// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper-A7S1EJ","text":"text-AEFwPs","icon":"icon-BsCc__"};